import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { alpha } from '@mui/material/styles';

const FavoritesHeader = () => {
  return (
    <Box 
      sx={{ 
        bgcolor: (t) => alpha(t.palette.secondary.main, 0.5), 
        py: 6, 
        textAlign: 'left',
        borderRadius: '16px',
        mb: 4,
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <Container maxWidth="xl">
        <Typography variant="h3" fontWeight="bold" color="primary.main" sx={{ mb: 1 }}>
          Tus favoritos,<br />siempre a la mano
        </Typography>
        <Typography variant="body1" color="primary.main" sx={{ opacity: 0.8 }}>
          Encuentra rápidamente los servicios que más te interesan y accede a ellos cuando los necesites.
        </Typography>
      </Container>
    </Box>
  );
};

export default FavoritesHeader;
